module.exports = __webpack_public_path__ + "img/type--3-spans--single-lang--de.bc76d8b7.jpg";